import ResouceCenterService from "@/screens/services/ResouceCenterService";
import ResourceCenterLayout from "@/screens/resource_center/ResourceCenterLayout";
import ResourceCenter from "@/screens/resource_center/ResourceCenter";
import Article from "@/screens/resource_center/Article";
const ArticleDetail = () => import("@/screens/resource_center/ArticleDetail");
const Database = () => import("@/screens/resource_center/Database");
import DesignCalendar from "@/screens/resource_center/DesignCalendar";
const DesignCalendarDetail = () => import("@/screens/resource_center/DesignCalendarDetail");
import Ebook from "@/screens/resource_center/Ebook";
const EbookDetail = () => import("@/screens/resource_center/EbookDetail");
const Material = () => import("@/screens/resource_center/Material");
import OnlineExhibition from "@/screens/resource_center/OnlineExhibition";
const OnlineExhibitionDetail = () => import("@/screens/resource_center/OnlineExhibitionDetail");
const TCDCResourceCenter = () => import("@/screens/resource_center/TCDCResourceCenter");

export const serviceResourceCenterRouter = [
    {
        path: ":branch/service/resource-center",
        name: "ResCenterService",
        component: ResouceCenterService,
    },
    {
        path: ":branch/service/resource-center",
        name: "ResourceCenterLayout",
        component: ResourceCenterLayout,
        children: [
            {
                path: "",
                name: "ResourceCenter",
                component: ResourceCenter,
            },
            {
                path: "article",
                name: "Article",
                component: Article,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "article/:slug_id",
                name: "ArticleDetail",
                component: ArticleDetail,
            },
            {
                path: "database",
                name: "Database",
                component: Database,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "database/:branch",
                name: "Database",
                component: Database,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "design-world-calendar",
                name: "DesignCalendar",
                component: DesignCalendar,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "design-world-calendar/:id",
                name: "DesignCalendarDetail",
                component: DesignCalendarDetail
            },
            {
                path: "e-book",
                name: "Ebook",
                component: Ebook,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "e-book/:slug_id",
                name: "EbookDetail",
                component: EbookDetail,
            },
            {
                path: "material",
                name: "Material",
                component: Material,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "material/:branch",
                name: "Material",
                component: Material,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "online-exhibition",
                name: "OnlineExhibition",
                component: OnlineExhibition,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "online-exhibition/:id",
                name: "OnlineExhibitionDetail",
                component: OnlineExhibitionDetail
            },
            {
                path: "tcdc-resource-center",
                name: "TCDCResourceCenter",
                component: TCDCResourceCenter,
                props: {
                    showHeader: true,
                },
            },
            {
                path: "tcdc-resource-center/:branch",
                name: "TCDCResourceCenter",
                component: TCDCResourceCenter,
                props: {
                    showHeader: true,
                },
            },
        ],
    }
]